import React, { useState, useEffect, useRef, useMemo } from 'react';
import ModuleTemplate from '../../ModuleTemplate';
import { useInstructionAudio } from '../../lib/useInstructionAudio';
import { useSpeakAnswer } from '../../lib/useSpeakAnswer';
import { fallbackWrongKey } from '../../lib/speechAnswerEvaluator';
import './SoundInWord.css';

const S3_BASE_URL = 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/vocabulary';

const IMAGE_MAP = {
  'автобус': 'bus', 'бант': 'bow', 'банка': 'jar', 'белка': 'squarel', 'волк': 'wolf','дом': 'house', 'гиря': 'heavy', 'груша': 'pear', 
  'жаба': 'toad', 'жук': 'beetle', 'змея': 'snake', 'зонт': 'umbrella', 'кошка': 'cat', 'кит': 'whale', 'корова': 'cow','лампа': 'lamp',
  'лимон': 'lemon', 'ложка': 'spoon', 'лук': 'onion', 'мак': 'mak', 'машина': 'car', 'мышь': 'mouse','мяч': 'ball', 'носки': 'socks', 
  'окно': 'window', 'палка': 'stick', 'рак': 'cancer', 'рыбы': 'fishes', 'рюкзак': 'back_pack','собака': 'dog', 'стакан': 'glass', 
  'стол': 'table', 'сыр': 'cheese', 'тыква': 'pumpkin', 'чайник': 'tea_pot', 'шапка': 'hat', 'шкаф': 'wardrobe', 'шуба': 'fur_coat', 
  'щётка': 'tooth_brush',  'цыплёнок': 'chicken', 'чашка': 'big_cup', 'утка': 'duck',
};

const TASKS_BY_AGE = {
  '4': [
    { pair: ['машина', 'утка', 'кит'], target: 'м', speakAs: 'М', position: 'в начале слова' },
    { pair: ['банка', 'кошка', 'мяч'], target: 'б' ,speakAs: 'Б', position: 'в начале слова' },
    { pair: ['палка', 'дом', 'рыбы'], target: 'п', speakAs: 'П', position: 'в начале слова' },
    { pair: ['кошка', 'груша', 'бант'], target: 'к', speakAs: 'К', position: 'в начале слова' },
    { pair: ['тыква', 'волк', 'сыр'], target: 'т', speakAs: 'Т', position: 'в начале слова' },
    { pair: ['носки', 'лук', 'рак'], target: 'н', speakAs: 'Н', position: 'в начале слова' },
  ],
  '5': [
    { pair: ['собака', 'кошка', 'рыбы'], target: 'с',speakAs: 'С', position: 'в начале слова' },
    { pair: ['шуба', 'дом', 'мяч'], target: 'ш', speakAs: 'Ш', position: 'в начале слова' },
    { pair: ['зонт', 'кошка', 'сыр'], target: 'з', speakAs: 'З', position: 'в начале слова' },
    { pair: ['жук', 'лук', 'мак'], target: 'ж', speakAs: 'Ж', position: 'в начале слова' }, 
    { pair: ['ложка', 'чашка', 'сыр'], target: 'л', speakAs: 'Л', position: 'в начале слова' }, 
    { pair: ['рак', 'дом', 'бант'], target: 'р', speakAs: 'Р', position: 'в начале слова' },
    { pair: ['цыплёнок', 'кошка', 'сыр'], target: 'ц', speakAs: 'Ц', position: 'в начале слова' }
  ],
  '6': [
     { pair: ['сыр', 'жук', 'лук'], target: 'с', speakAs: 'С', position: 'в начале слова' }, 
    { pair: ['шкаф', 'окно', 'сыр'], target: 'ш', speakAs: 'Ш', position: 'в начале слова' },
    { pair: ['змея', 'кошка', 'сыр'], target: 'з', speakAs: 'З', position: 'в начале слова' },
    { pair: ['жаба', 'лук', 'сыр'], target: 'ж', speakAs: 'Ж', position: 'в начале слова' },
    { pair: ['лампа', 'кошка', 'сыр'], target: 'л', speakAs: 'Л', position: 'в начале слова' },
    { pair: ['лимон', 'волк', 'сыр'], target: 'л', soft: true, speakAs: 'мягкий Л', position: 'в начале слова' },
    { pair: ['рыбы', 'кошка', 'окно'], target: 'р', speakAs: 'Р', position: 'в начале слова' },
    { pair: ['рюкзак', 'груша', 'сыр'], target: 'р', soft: true, speakAs: 'мягкий Р', position: 'в начале слова' },
    { pair: ['чайник', 'кошка', 'щётка'], target: 'ч', speakAs: 'Ч', position: 'в начале слова' },
    { pair: ['щётка', 'кошка', 'шапка'], target: 'щ', speakAs: 'Щ', position: 'в начале слова' },
    { pair: ['банка', 'корова', 'чашка'], target: 'р', speakAs: 'Р', position: 'в середине слова' },
    { pair: ['гиря', 'груша', 'сыр'], target: 'р', soft: true, speakAs: 'мягкий Р', position: 'в середине слова' },
    { pair: ['дом', 'мяч', 'жук'], target: 'к', speakAs: 'К', position: 'в конце слова' },
    { pair: ['стол', 'кошка', 'щётка'], target: 'с', speakAs: 'С', position: 'в стечении согласных' },
    { pair: ['чайник', 'мышь', 'щётка'], target: 'ш', speakAs: 'Ш', position: 'в стечении согласных' }
  ],
  '7-9':[
    { pair: ['сыр', 'жук', 'лук'], target: 'с', speakAs: 'С', position: 'в начале слова' }, 
    { pair: ['шкаф', 'окно', 'сыр'], target: 'ш', speakAs: 'Ш', position: 'в начале слова' },
    { pair: ['змея', 'кошка', 'сыр'], target: 'з', speakAs: 'З', position: 'в начале слова' },
    { pair: ['жаба', 'лук', 'сыр'], target: 'ж', speakAs: 'Ж', position: 'в начале слова' },
    { pair: ['лампа', 'кошка', 'сыр'], target: 'л', speakAs: 'Л', position: 'в начале слова' },
    { pair: ['лимон', 'волк', 'сыр'], target: 'л', soft: true, speakAs: 'мягкий Л', position: 'в начале слова' },
    { pair: ['рыбы', 'кошка', 'окно'], target: 'р', speakAs: 'Р', position: 'в начале слова' },
    { pair: ['рюкзак', 'груша', 'сыр'], target: 'р', soft: true, speakAs: 'мягкий Р', position: 'в начале слова' },
    { pair: ['чайник', 'кошка', 'щётка'], target: 'ч', speakAs: 'Ч', position: 'в начале слова' },
    { pair: ['щётка', 'кошка', 'шапка'], target: 'щ', speakAs: 'Щ', position: 'в начале слова' },
    { pair: ['банка', 'корова', 'чашка'], target: 'р', speakAs: 'Р', position: 'в середине слова' },
    { pair: ['гиря', 'груша', 'сыр'], target: 'р', soft: true, speakAs: 'мягкий Р', position: 'в середине слова' },
    { pair: ['дом', 'мяч', 'жук'], target: 'к', speakAs: 'К', position: 'в конце слова' },
    { pair: ['стол', 'кошка', 'щётка'], target: 'с', speakAs: 'С', position: 'в стечении согласных' },
    { pair: ['чайник', 'мышь', 'щётка'], target: 'ш', speakAs: 'Ш', position: 'в стечении согласных' }
  ],
  '10-12':[
    { pair: ['сыр', 'жук', 'лук'], target: 'с', speakAs: 'С', position: 'в начале слова' }, 
    { pair: ['шкаф', 'окно', 'сыр'], target: 'ш', speakAs: 'Ш', position: 'в начале слова' },
    { pair: ['змея', 'кошка', 'сыр'], target: 'з', speakAs: 'З', position: 'в начале слова' },
    { pair: ['жаба', 'лук', 'сыр'], target: 'ж', speakAs: 'Ж', position: 'в начале слова' },
    { pair: ['лампа', 'кошка', 'сыр'], target: 'л', speakAs: 'Л', position: 'в начале слова' },
    { pair: ['лимон', 'волк', 'сыр'], target: 'л', soft: true, speakAs: 'мягкий Л', position: 'в начале слова' },
    { pair: ['рыбы', 'кошка', 'окно'], target: 'р', speakAs: 'Р', position: 'в начале слова' },
    { pair: ['рюкзак', 'груша', 'сыр'], target: 'р', soft: true, speakAs: 'мягкий Р', position: 'в начале слова' },
    { pair: ['чайник', 'кошка', 'щётка'], target: 'ч', speakAs: 'Ч', position: 'в начале слова' },
    { pair: ['щётка', 'кошка', 'шапка'], target: 'щ', speakAs: 'Щ', position: 'в начале слова' },
    { pair: ['банка', 'корова', 'чашка'], target: 'р', speakAs: 'Р', position: 'в середине слова' },
    { pair: ['гиря', 'груша', 'сыр'], target: 'р', soft: true, speakAs: 'мягкий Р', position: 'в середине слова' },
    { pair: ['дом', 'мяч', 'жук'], target: 'к', speakAs: 'К', position: 'в конце слова' },
    { pair: ['стол', 'кошка', 'щётка'], target: 'с', speakAs: 'С', position: 'в стечении согласных' },
    { pair: ['чайник', 'мышь', 'щётка'], target: 'ш', speakAs: 'Ш', position: 'в стечении согласных' }
  ],
  '13-15':[
    { pair: ['сыр', 'жук', 'лук'], target: 'с', speakAs: 'С', position: 'в начале слова' }, 
    { pair: ['шкаф', 'окно', 'сыр'], target: 'ш', speakAs: 'Ш', position: 'в начале слова' },
    { pair: ['змея', 'кошка', 'сыр'], target: 'з', speakAs: 'З', position: 'в начале слова' },
    { pair: ['жаба', 'лук', 'сыр'], target: 'ж', speakAs: 'Ж', position: 'в начале слова' },
    { pair: ['лампа', 'кошка', 'сыр'], target: 'л', speakAs: 'Л', position: 'в начале слова' },
    { pair: ['лимон', 'волк', 'сыр'], target: 'л', soft: true, speakAs: 'мягкий Л', position: 'в начале слова' },
    { pair: ['рыбы', 'кошка', 'окно'], target: 'р', speakAs: 'Р', position: 'в начале слова' },
    { pair: ['рюкзак', 'груша', 'сыр'], target: 'р', soft: true, speakAs: 'мягкий Р', position: 'в начале слова' },
    { pair: ['чайник', 'кошка', 'щётка'], target: 'ч', speakAs: 'Ч', position: 'в начале слова' },
    { pair: ['щётка', 'кошка', 'шапка'], target: 'щ', speakAs: 'Щ', position: 'в начале слова' },
    { pair: ['банка', 'корова', 'чашка'], target: 'р', speakAs: 'Р', position: 'в середине слова' },
    { pair: ['гиря', 'груша', 'сыр'], target: 'р', soft: true, speakAs: 'мягкий Р', position: 'в середине слова' },
    { pair: ['дом', 'мяч', 'жук'], target: 'к', speakAs: 'К', position: 'в конце слова' },
    { pair: ['стол', 'кошка', 'щётка'], target: 'с', speakAs: 'С', position: 'в стечении согласных' },
    { pair: ['чайник', 'мышь', 'щётка'], target: 'ш', speakAs: 'Ш', position: 'в стечении согласных' }
  ],
  '16+':[
    { pair: ['сыр', 'жук', 'лук'], target: 'с', speakAs: 'С', position: 'в начале слова' }, 
    { pair: ['шкаф', 'окно', 'сыр'], target: 'ш', speakAs: 'Ш', position: 'в начале слова' },
    { pair: ['змея', 'кошка', 'сыр'], target: 'з', speakAs: 'З', position: 'в начале слова' },
    { pair: ['жаба', 'лук', 'сыр'], target: 'ж', speakAs: 'Ж', position: 'в начале слова' },
    { pair: ['лампа', 'кошка', 'сыр'], target: 'л', speakAs: 'Л', position: 'в начале слова' },
    { pair: ['лимон', 'волк', 'сыр'], target: 'л', soft: true, speakAs: 'мягкий Л', position: 'в начале слова' },
    { pair: ['рыбы', 'кошка', 'окно'], target: 'р', speakAs: 'Р', position: 'в начале слова' },
    { pair: ['рюкзак', 'груша', 'сыр'], target: 'р', soft: true, speakAs: 'мягкий Р', position: 'в начале слова' },
    { pair: ['чайник', 'кошка', 'щётка'], target: 'ч', speakAs: 'Ч', position: 'в начале слова' },
    { pair: ['щётка', 'кошка', 'шапка'], target: 'щ', speakAs: 'Щ', position: 'в начале слова' },
    { pair: ['банка', 'корова', 'чашка'], target: 'р', speakAs: 'Р', position: 'в середине слова' },
    { pair: ['гиря', 'груша', 'сыр'], target: 'р', soft: true, speakAs: 'мягкий Р', position: 'в середине слова' },
    { pair: ['дом', 'мяч', 'жук'], target: 'к', speakAs: 'К', position: 'в конце слова' },
    { pair: ['стол', 'кошка', 'щётка'], target: 'с', speakAs: 'С', position: 'в стечении согласных' },
    { pair: ['чайник', 'мышь', 'щётка'], target: 'ш', speakAs: 'Ш', position: 'в стечении согласных' }
  ],
};

const SoundInWord = ({ ageGroup, onBack, onComplete }) => {
  const { play: playInstruction } = useInstructionAudio();
  const { start: startSpeakRecognition, stop: stopSpeakRecognition } = useSpeakAnswer('SoundInWord');
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [answerLog, setAnswerLog] = useState([]);
  const [showResult, setShowResult] = useState(false);
  const [selectedMode, setSelectedMode] = useState(null);
  const [blinkTarget, setBlinkTarget] = useState('speak');
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [hasSpoken, setHasSpoken] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [isCorrect, setIsCorrect] = useState(null);
  const [isDisabled, setIsDisabled] = useState(false);
  const [shuffledCards, setShuffledCards] = useState([]);

  const hasSpokenRef = useRef(false);

  const isCorrectWord = (word, targetBase, isSoft) => {
    const w = word.toLowerCase();
    const t = targetBase.toLowerCase();
    const softVowels = ['и', 'е', 'ё', 'ю', 'я'];

    for (let i = 0; i < w.length; i++) {
      if (w[i] === t) {
        const nextChar = w[i + 1];
        if (isSoft) {
          if (softVowels.includes(nextChar) || nextChar === 'ь') return true;
        } else {
          if (!softVowels.includes(nextChar)) return true;
          if (nextChar === 'ь' && i === w.length - 2) return true; 
        }
      }
    }
    return false;
  };

  const tasks = useMemo(() => {
    const rawTasks = TASKS_BY_AGE[ageGroup] || TASKS_BY_AGE['4'];
    return rawTasks.map((task) => {
      const correctWordId = task.pair.find(word => isCorrectWord(word, task.target, task.soft)) || task.pair[0];
      return {
        sound: task.speakAs || `звук ${task.target.toUpperCase()}`,
        position: task.position || 'не указано',
        options: task.pair.map(word => ({
          id: word,
          text: word.charAt(0).toUpperCase() + word.slice(1),
          isCorrect: word === correctWordId 
        }))
      };
    });
  }, [ageGroup]);

  const currentTask = tasks[currentQuestionIndex];
  const totalQuestions = tasks.length;

  useEffect(() => {
    if (currentTask && shuffledCards.length === 0) setShuffledCards([...currentTask.options].sort(() => Math.random() - 0.5));
  }, [currentTask, currentQuestionIndex, shuffledCards.length]);

  useEffect(() => {
    if (selectedMode) return;
    const interval = setInterval(() => setBlinkTarget(prev => (prev === 'speak' ? 'show' : 'speak')), 700);
    return () => clearInterval(interval);
  }, [selectedMode]);

  const handleModeSelect = (mode) => setSelectedMode(mode);

  const speakInstruction = () => {
    if (hasSpokenRef.current || !currentTask || !selectedMode) return;
    hasSpokenRef.current = true; setHasSpoken(true); setIsSpeaking(true); setIsDisabled(true);
    const actionText = selectedMode === 'show' ? 'Покажи' : 'Назови';
    const text = `${actionText} слово со звуком "${currentTask.sound}"`;
    playInstruction(text, () => {
      setIsSpeaking(false);
      setIsDisabled(false);
      if (selectedMode === 'speak') startListening();
    });
  };

  // Режим "Говорить": слушаем ребёнка через распознаватель речи и сравниваем
  // сказанное с одним из трёх слов на карточках.
  const startListening = () => {
    if (!currentTask) return;
    startSpeakRecognition(
      currentTask.options.map((o) => ({ key: o.id, text: o.id })),
      {
        onResult: ({ matchedKey }) => {
          setIsDisabled(true);
          const correctId = currentTask.options.find(o => o.isCorrect)?.id;
          const resolvedKey = matchedKey || fallbackWrongKey(
            currentTask.options.map(o => ({ key: o.id })),
            correctId
          );
          const isAnswerCorrect = resolvedKey === correctId;
          setIsCorrect(isAnswerCorrect);
          setSelectedCard(resolvedKey);
          recordAnswer(isAnswerCorrect, { chosenWord: resolvedKey, correctWord: correctId, mode: 'speak' });
          setTimeout(() => goToNextQuestion(), 1500);
        },
      }
    );
  };

  useEffect(() => {
    if (selectedMode && currentTask && !showResult && !hasSpoken) {
      const timer = setTimeout(() => speakInstruction(), 500);
      return () => clearTimeout(timer);
    }
  }, [currentQuestionIndex, selectedMode, showResult, hasSpoken]);

  const recordAnswer = (isAnswerCorrect, detail = {}) => {
    setAnswers(prev => [...prev, isAnswerCorrect]);
    setAnswerLog(prev => [...prev, {
      sound: currentTask.sound,
      position: currentTask.position,
      correct: isAnswerCorrect,
      ...detail,
    }]);
  };

  const handleCardClick = (card) => {
    if (isDisabled || isSpeaking || selectedMode !== 'show') return;
    setIsDisabled(true); setSelectedCard(card.id);
    const isAnswerCorrect = card.isCorrect;
    setIsCorrect(isAnswerCorrect);
    const correctId = currentTask.options.find(o => o.isCorrect)?.id;
    recordAnswer(isAnswerCorrect, { chosenWord: card.id, correctWord: correctId, mode: 'show' });
    setTimeout(() => { if (currentQuestionIndex < totalQuestions - 1) goToNextQuestion(); else setShowResult(true); }, 1500);
  };

  const goToNextQuestion = () => {
    stopSpeakRecognition();
    if (currentQuestionIndex < totalQuestions - 1) {
      setCurrentQuestionIndex((prev) => prev + 1);
      setShuffledCards([]);
      setSelectedCard(null);
      setIsCorrect(null);
      setIsDisabled(false);
      setHasSpoken(false);
      hasSpokenRef.current = false;
    } else {
      setShowResult(true);
    }
  };

  const computeResult = () => {
    const correctCount = answers.filter(a => a === true).length;
    const score = totalQuestions > 0 ? Math.round((correctCount / totalQuestions) * 100) : 0;

    const failedItems = answerLog
      .filter(a => !a.correct)
      .map(a => ({ sound: a.sound, position: a.position, chosenWord: a.chosenWord, correctWord: a.correctWord }));
    const hasUnverifiedSpeakAnswers = answerLog.some(a => a.mode === 'speak');

    return { 
      testId: 'SoundInWord', 
      score, 
      details: { 
        total: totalQuestions, 
        correct: correctCount, 
        failedItems,
        hasUnverifiedSpeakAnswers,
        log: answerLog,
      } 
    };
  };

  const getImageSrc = (id) => `${S3_BASE_URL}/${IMAGE_MAP[id] || 'placeholder'}.png`;

  useEffect(() => {
    if (showResult) {
      const timer = setTimeout(() => {
        if (onComplete) onComplete(computeResult());
        else onBack();
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [showResult]);

  if (showResult) {
    const correctCount = answers.filter((a) => a === true).length;
    return (
      <ModuleTemplate
        progress={answers}
        totalQuestions={totalQuestions}
        forceStop={true}
        onComplete={onComplete || onBack}
      >
        <div className="sound-in-word-result-content">
          <h2 className="sound-in-word-result-title">🎉 Упражнение завершено!</h2>
          <div className="sound-in-word-result-score">
            <span className="sound-in-word-score-number">{correctCount}</span>
            <span className="sound-in-word-score-total"> / {totalQuestions}</span>
          </div>
        </div>
      </ModuleTemplate>
    );
  }

  return (
    <ModuleTemplate
      progress={answers}
      totalQuestions={totalQuestions}
      forceStop={true}
      onComplete={onComplete || onBack}
      extraContent={!selectedMode ? 'Выбери режим' : selectedMode === 'speak' ? `Назови слово со звуком "${currentTask?.sound || ''}"` : `Покажи слово со звуком "${currentTask?.sound || ''}"`}
      disabled={!selectedMode}
    >
      <div className="sound-in-word-container">
        {!selectedMode && (
          <div className="mode-buttons-container">
            <button onClick={() => handleModeSelect('speak')} className={`mode-btn ${blinkTarget === 'speak' ? 'mode-btn-active' : ''}`}>Говорить</button>
            <button onClick={() => handleModeSelect('show')} className={`mode-btn ${blinkTarget === 'show' ? 'mode-btn-active' : ''}`}>Показать</button>
          </div>
        )}
        <div className={`sound-in-word-speaking-badge ${isSpeaking ? 'active' : ''}`}>
          <span className="sound-in-word-speaking-icon">🔊</span><span className="sound-in-word-speaking-text">Слушай...</span>
        </div>
        <div className="sound-in-word-cards-grid">
          {shuffledCards.map((card) => {
            const isSelected = selectedCard === card.id;
            const showCorrect = isSelected && isCorrect === true;
            const showWrong = isSelected && isCorrect === false;
            const showCorrectHint = selectedCard !== null && isCorrect === false && !isSelected && card.isCorrect;
            return (
              <div
                key={card.id}
                className={`sound-in-word-card-wrapper ${!isDisabled && !isSpeaking && selectedMode === 'show' ? 'clickable' : ''} ${showCorrect ? 'answer-correct' : ''} ${showWrong ? 'answer-wrong' : ''} ${showCorrectHint ? 'answer-correct-hint' : ''}`}
                onClick={() => handleCardClick(card)}
              >
                <img src={getImageSrc(card.id)} alt="" className="sound-in-word-card-image" onError={(e) => { e.target.style.display = 'none'; }} />
              </div>
            );
          })}
        </div>
      </div>
    </ModuleTemplate>
  );
};

export default SoundInWord;